import styled from 'styled-components'
import { mainColor, mainFont } from '../../../styles/global'

export const FlyingStartWrapper = styled.div`
    width:75%;
    height:100%;
    @media screen and (max-width: 768px) {
        width:100%;

    }
    > h1{
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 800;
        color: ${mainColor};
        font-weight: 900;
        font-size: 40px;
        line-height: 43px;
        letter-spacing: 0.01em;
        color: #090458;
        @media screen and (max-width: 768px) {
            text-align: center;
            padding:0 40px;
            font-size: 21px;
            line-height:25px;
            letter-spacing: 0.01em;
            font-weight: 750;

        }
    }
    >p{
            font-family: ${mainFont};
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 25px;
            letter-spacing: 0.01em;
            color: #8D8D8D;
            @media screen and (max-width: 768px) {
                font-size: 10px;
                padding:5px 30px;
                text-align: center;
                line-height: 14px;

            }

    }
   



`
export const HighLightBox = styled.div`
    display:flex;
    gap:2rem;
    margin-top:40px;
    @media screen and (max-width: 768px) {
        gap:1rem;
        margin-top:0px;
        margin-bottom: 10px;

    }
`;
export const NumberListButton = styled.div`
    position:relative;
    > div {
        background:${mainColor};
        height:45px;
        width:45px;
        border-radius:50%;
        color:#fff;
        display:flex;
        justify-content:center;
        align-items: center;
        @media screen and (max-width: 768px) {
            height:35px;
            width:35px;
            font-size:12px;
        }
    }
    .count-line::before {
        content: "";
        background:${mainColor};
        width:2px;
        height:50px;
        top:60px;
        left:50%;
        position: absolute;
        @media screen and (max-width: 768px) {
            top:40px;
            height:40px;

        }
      }
`;
export const Content = styled.div`
      padding:10px 0 ;
      @media screen and (max-width: 768px) {
      marging-top:10px;

      }
      h3{  
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 33px;
        letter-spacing: 0.01em;
        color: ${mainColor};
        white-space: nowrap;
        @media screen and (max-width: 768px) {
            // font-family:Verdana, sans-serif;
            font-weight: 750;
            font-size: 15px;
            line-height: 18px;
        }
      }
      p{

        font-family: ${mainFont};
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 25px;
        letter-spacing: 0.01em;
        color: #8D8D8D;       
        @media screen and (max-width: 768px) {
            font-size: 10px;
            line-height: 14px;
            margin:10px 0px;
        line-height: 25px;

        }
      }

`;

export const HighLightSection = styled.div`

      display:flex;
      flex-direction: column;
     
`

